<template>
  <div>
    <div class="brand_infoBox text-center mt50">
      <h1 class="brand_logo"></h1>
    </div>
    <div class="fullbox">
      <div class="fullbox_cont">
        <div class="title_wran">
          <img src="@/assets/images/update/reupdate.png"
               alt="re firmware update"
               class="img-responsive">
          <section class="title_wran_text">
            <h3>{{ $t('reUpdate.title') }}</h3>
            <p v-for="(contentLine, index) in $t('reUpdate.content')" :key="index">{{ contentLine }}</p>
          </section>
        </div>

        <div class="table-responsive mt30">
          <table class="table table_base table_upload">
            <thead>
              <tr>
                <th v-for="(items, index) in $t('reUpdate.updateTable.itemtitle')" :key="index">{{ items }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(upgradeInfo, index) in upgradeTable"
                  :key="index">
                <td>
                  <img :src="upgradeInfo.image"
                       alt="Driver"
                       class="img-responsive">
                  <p class="hardware_name">{{ $t('reUpdate.device.'+(upgradeInfo.part).toLowerCase()) }}
                    <span>{{upgradeInfo.partName}}</span>
                  </p>
                </td>
                <td>
                  <div class="state_run"
                       :class="upgradeInfo.style">
                    <div class="progress">
                      <div class="progress-bar"
                           role="progressbar"
                           aria-valuenow="60"
                           aria-valuemin="0"
                           aria-valuemax="100"
                           :style="{'width': upgradeInfo.progress + '%'}"></div>
                    </div>
                    <span>{{upgradeInfo.progress}}%</span>
                  </div>
                </td>
                <td>{{upgradeInfo.message}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <Loading :loadingText="loadingText"
             v-if="boolLoading" />
    <uiv-modal v-model="modalOpen"
               class="v-modal-style"
               :backdrop="false"
               :footer="!hideFooter">
      <h4 slot="header"
          class="modal-title">{{ modal.data.title }}</h4>
      <p slot="default">{{ modal.data.content }}</p>
      <template slot="footer">
        <button type="button"
                id="btnOK"
                class="btn btn-default"
                @click="modal.btnFunc.ok">{{ modal.btn.ok }}</button>
        <button v-show="!isHideCancelBtn"
                type="button"
                id="btnCancel"
                class="btn btn-default"
                @click="modal.btnFunc.cancel">{{ modal.btn.cancel }}</button>
      </template>
    </uiv-modal>
  </div>
</template>
<script>
import { funcWebViewHeight } from '@/utils/web-style/web-style';
import { funcEncryptData, funcDecryptData } from '@/utils/crypt';
import { mapGetters } from 'vuex';
import * as connectBikeAPI from '@/api/connect-bike';
import { bikeReupdateFw } from '@/mixins/websocket-forceupdate';
import Loading from '@/components/Loading.vue';
import { allowPartNo, funcOriginalPartNo } from '@/utils/allowPartNo';

export default {
  name: 'ReFwUpdate',
  data () {
    return {
      fwData: {
        'C': {
          'FWData': '',
          'FWChecksum': ''
        },
        'P': {
          'FWData': '',
          'FWChecksum': ''
        },
        'D': {
          'FWData': '',
          'FWChecksum': ''
        },
        'M': {
          'FWData': '',
          'FWChecksum': ''
        }
      },
      mustUpgradeParts: [],
      bikeInfo: {},
      driverPartNo: '',
      upgradeTable: [],
      latestFw: [],
      modalOpen: false,
      modal: {
        data: {
          title: this.$t('bikeOverview.modalTitle'),
          content: this.$t('bikeOverview.modalContent')
        },
        btn: {
          ok: this.$t('bikeOverview.modalBtnOk'),
          cancel: this.$t('bikeOverview.modalBtnCancel')
        },
        btnFunc: {
          ok: this.funcCloseDialog,
          cancel: this.funcCloseDialog
        }
      },
      hideFooter: false,
      isHideCancelBtn: true,
      loadingText: '',
      boolLoading: false,
      isSecondUpdate: false
    };
  },
  mixins: [bikeReupdateFw],
  mounted () {
    // 先讀取所有腳踏車的 part# mid 的配置, 透過 console mid
    funcWebViewHeight();
    // this.funcGetBikeInfoApi()
    // 開始更新
    // this.funcCheckNextStep()
  },
  computed: {
    // getLocalStoreDeviceInfo，進入更新頁面當時腳踏車的配置
    ...mapGetters({
      getBikeUpdateStatus: 'bikeConnect/getBikeUpdateStatus',
      getDeviceInfo: 'bikeConnect/getDeviceInfo',
      getLocalStoreDeviceInfo: 'bikeConnect/getLocalStoreDeviceInfo'
    })
  },
  components: { Loading },
  methods: {
    funcOpenDialog (message, okfunc, cancelfunc) {
      this.modalOpen = true;
      this.modal.data.title = 'Message';
      this.modal.data.content = message;
      this.modal.btnFunc.ok = okfunc || this.funcCloseDialog;
      this.modal.btnFunc.cancel = cancelfunc || this.funcCloseDialog;
    },
    funcCloseDialog () {
      this.modalOpen = false;
    },
    async funcGetBikeLatestFWApi () {
      let partNoList = [this.getDeviceInfo['ConsolePN'], this.driverPartNo];
      let message = { PartNoList: partNoList };
      const encryptData = funcEncryptData(message);
      try {
        const data = await connectBikeAPI.getBikeLatestFW(encryptData)
          .then(res => funcDecryptData(JSON.parse(res)));
        // console.log('funcGetBikeLatestFWApi', data)
        if (data.ErrorCode > 0) {
          // console.log('funcGetBikeLatestFWApi', data)
          this.boolLoading = false;
          let message = `[P01] ${data.ErrorCode}` + this.$t('errorCodeMsg.20012');
          this.hideFooter = false;
          this.funcOpenDialog(message, this.funcBackToConnect);
          return;
        }
        this.latestFw = data.FwList;
        this.funcComputedUpgradePart();
      } catch (e) {
        this.boolLoading = false;
        let message = `[P01] ` + this.$t('errorCodeMsg.20012');
        this.hideFooter = false;
        this.funcOpenDialog(message, this.funcBackToConnect);
      }
    },
    async funcGetPartFWDataAPI (partType, partNo) {
      let message = { PartNo: partNo };
      const encryptData = funcEncryptData(message);
      try {
        const data = await connectBikeAPI.getPartFWData(encryptData)
          .then(res => funcDecryptData(JSON.parse(res)));
          // console.log('funcGetPartFWDataAPI', data)
        if (data.ErrorCode > 0) {
          let message = `[P02] ${data.ErrorCode}` + this.$t('errorCodeMsg.20012');
          this.hideFooter = false;
          this.funcOpenDialog(message, this.funcBackToConnect);
          return;
        }
        this.fwData[partType] = data;
        return data;
      } catch (e) {
        let message = `[P02]` + this.$t('errorCodeMsg.20012');
        this.hideFooter = false;
        this.funcOpenDialog(message, this.funcBackToConnect);
      }
    },
    async funcGetBikeInfoApi () {
      let message = { FrameNo: '', MID: this.getDeviceInfo['ConsoleMID'] };
      const encryptData = funcEncryptData(message);
      try {
        const data = await connectBikeAPI.getBikeInfo(encryptData)
          .then(res => funcDecryptData(JSON.parse(res)));
        if (data.ErrorCode > 0) {
          this.boolLoading = false;
          let message = `[B04] ${data.ErrorCode}` + this.$t('errorCodeMsg.20012');
          this.hideFooter = false;
          this.funcOpenDialog(message, this.funcBackToConnect);
          return;
        }
        this.bikeInfo = data.BikeInfo;
        this.driverPartNo = this.bikeInfo['DriverPN'];
        this.funcGetBikeLatestFWApi();
      } catch (e) {
        this.boolLoading = false;
        let message = `[B04]` + this.$t('errorCodeMsg.20012');
        this.hideFooter = false;
        this.funcOpenDialog(message, this.funcBackToConnect);
      }
    },
    funcGetPartName (partType) {
      var partName = '';
      this.latestFw.forEach((item) => {
        if (item.PartType === partType) {
          partName = item.PartName;
        }
      });
      return partName;
    },
    funcChangeUpgradeStatus (partType, status, message, progress) {
      // (零件型態, 更新狀態,  提示訊息,更新進度)
      this.upgradeTable.forEach((item) => {
        if (item.type === partType) {
          if (progress) {
            item.progress = progress;
          }
          item.message = message;
          item.style = {
            'state_success': status === 'S',
            'state_process': status === 'P',
            'state_failed': status === 'F'
          };
        }
      });
    },
    async funcForceUpgradeConsole () {
      if (this.fwData['C']['FWData'] === '') {
        await this.funcGetPartFWDataAPI('C', this.getDeviceInfo['ConsolePN']);
      }
      // console.log(this.fwData['C']["FWData"], this.fwData['C']["FWChecksum"])
      this.ws.UpgradeConsole(this.fwData['C']['FWData'], this.fwData['C']['FWChecksum']);
    },
    async funcForceUpgradeDriver () {
      let localStoragePN = funcOriginalPartNo(this.getLocalStoreDeviceInfo['DriverPN']);
      let dbPN = funcOriginalPartNo(this.bikeInfo['DriverPN']);
      if (!this.funcPNisValidComponent(dbPN, localStoragePN)) {
        // console.log("driver 配置異常 ")
        let message = this.$t('reUpdate.driverPNwrong');
        this.funcChangeUpgradeStatus('D', 'F', message);
        return;
      }
      if (this.fwData['D']['FWData'] === '') {
        await this.funcGetPartFWDataAPI('D', this.driverPartNo);
      }
      // console.log(this.fwData['D']["FWData"], this.fwData['D']["FWChecksum"])
      this.ws.UpgradeDriver(this.fwData['D']['FWData'], this.fwData['D']['FWChecksum']);
    },
    async funcForceUpgradeBroseMotor () {
      if (!this.funcPNisValidComponent(this.bikeInfo['DriverPN'], this.getLocalStoreDeviceInfo['DriverPN'])) {
        // console.log("motor 配置異常 ")
        let message = this.$t('reUpdate.driverPNwrong');
        this.funcChangeUpgradeStatus('M', 'F', message);
        return;
      }
      if (this.fwData['M']['FWData'] === '') {
        await this.funcGetPartFWDataAPI('M', this.driverPartNo);
      }
      this.ws.UpgradeBroseDrive(this.fwData['M']['FWData'], this.fwData['M']['FWChecksum'], this.fwData['M']['FWParametersData'], this.fwData['M']['FWParametersChecksum']);
    },
    async funcForceUpgradeDisplay () {
      // 取得裝置的Display part# ，透過api拿取FW data
      // DisplayPN 為NONE 是Display PN H3070的更新失敗特性
      if (this.fwData['P']['FWData'] === '') {
        // let strDisplayPN = this.getDeviceInfo['DisplayPN'] === 'NONE' ? 'H3070' : this.getDeviceInfo['DisplayPN'];
        let strDisplayPN = 'H3070';
        await this.funcGetPartFWDataAPI('P', strDisplayPN);
      }
      // console.log(this.fwData['C']["FWData"], this.fwData['C']["FWChecksum"])
      this.ws.UpgradeDisplay(this.fwData['P']['FWData'], this.fwData['P']['FWChecksum']);
    },
    funcPNisValidComponent (DBInfoPN, BikePN) {
      // console.log("腳踏車PN", BikePN)
      // console.log("DB PN", DBInfoPN)
      if (DBInfoPN !== BikePN) return false;
      return true;
    },
    funcComputedUpgradePart () {
      if (this.getBikeUpdateStatus.ConsoleUpdate === 'N') {
        let upgradeInfo = { part: 'Console', image: '', partName: '', type: 'C', progress: 0, style: '', message: '' };
        let originPartNo = funcOriginalPartNo(this.getDeviceInfo['ConsolePN']);
        let consoleImageName = allowPartNo[originPartNo].photo;
        upgradeInfo.image = require(`@/assets/images/diagnosis/${consoleImageName}`);
        upgradeInfo.partName = this.funcGetPartName('C');
        this.upgradeTable.push(upgradeInfo);
        // console.log(this.funcGetPartName('C'))
        this.mustUpgradeParts.push(this.funcForceUpgradeConsole);
      }
      if (this.getBikeUpdateStatus.DriverUpdate === 'N') {
        let upgradeInfo = { part: 'Driver', image: '', partName: '', type: 'D', progress: 0, style: '', message: '' };
        upgradeInfo.partName = this.funcGetPartName('D');
        upgradeInfo.image = require('@/assets/images/update/Driver.jpg');
        this.upgradeTable.push(upgradeInfo);
        this.mustUpgradeParts.push(this.funcForceUpgradeDriver);
      }
      if (this.getBikeUpdateStatus.DisplayUpdate === 'N') {
        let upgradeInfo = { part: 'Display', image: '', partName: '', type: 'P', progress: 0, style: '', message: '' };
        upgradeInfo.partName = this.funcGetPartName('P');
        upgradeInfo.image = require('@/assets/images/update/LCD_Display.jpg');
        this.upgradeTable.push(upgradeInfo);
        this.mustUpgradeParts.push(this.funcForceUpgradeDisplay);
      }
      if (this.getBikeUpdateStatus.MotorUpdate === 'N') {
        let upgradeInfo = { part: 'Driver', image: '', partName: '', type: 'M', progress: 0, style: '', message: '' };
        upgradeInfo.partName = this.funcGetPartName('D');
        upgradeInfo.image = require('@/assets/images/update/Driver_motor.png');
        this.upgradeTable.push(upgradeInfo);
        this.mustUpgradeParts.push(this.funcForceUpgradeBroseMotor);
      }
      this.boolLoading = false;
      this.funcCheckNextStep();
    },
    funcCheckNextStep () {
      this.mustUpgradeParts[0]();
    },
    funcCheckIsFinalStep () {
      let isFinal = true;
      if (this.mustUpgradeParts.length === 0) {
        // 全部更新完成
        // console.log('全部更新完成')
        let message = this.$t('reUpdate.updateSuccess');
        this.hideFooter = false;
        this.funcOpenDialog(message, this.funcBackToConnect);
        isFinal = true;
        this.$store.dispatch('bikeConnect/setBikeFlag', true);
      } else {
        isFinal = false;
      }
      return isFinal;
    },
    funcBackToConnect () {
      this.$router.push('/connect');
    }
  }
};
</script>

<style lang="scss" scoped>
.fullbox_cont {
  @include pc-width {
    width: 1200px;
  }
  .title_wran {
    @include gridbox(grid, 140px auto, 30px, 0);
    margin: 0 auto;
    width: 600px;
    .title_wran_text {
      align-self: center;
      h3 {
        color: $red;
        font-weight: bold;
        margin-top: 0;
        &:before {
          content: "\e928";
          display: inline-block;
          @include rem(font-size, 2.4rem);
          @extend %icons-m;
          margin-right: 10px;
        }
      }
    }
  }
  .table_upload {
    thead {
      tr {
        th {
          &:first-child {
            width: 250px;
          }
          &:nth-child(2) {
            width: auto;
          }
          &:last-child {
            text-align: left;
            width: 360px;
          }
        }
      }
    }
    tbody {
      tr {
        td {
          &:last-child {
            color: $black;
            text-align: left;
          }

          .state_run {
            @include gridbox(grid, auto 60px, 10px, 0);

            &.state_success {
              color: $light_green;
              .progress {
                .progress-bar {
                  background-color: $light_green;
                }
              }
            }

            &.state_process {
              color: $yellow;
              .progress {
                .progress-bar {
                  background-color: $yellow;
                }
              }
            }

            &.state_failed {
              color: $red;
              .progress {
                .progress-bar {
                  background-color: $red;
                }
              }
            }

            .progress {
              align-self: center;
              height: 8px;
              margin-bottom: 0;
            }

            span {
              justify-self: center;
            }
          }
        }
      }
    }
  }
}
</style>
